const proxyApi = "/apps/24gt";
// App Proxy (02.10.2026, #39) — counterpart to app PR #354 (create_variant
// activated on the proxy lane). Old direct URL kept for rollback below.
// const createVariantUrl =
//   "https://app.24-gute-taten.de/api/store/7bd87d-2/create_variant";
const createVariantUrl = proxyApi + "/store/7bd87d-2/create_variant";
const updateVariantUrl = proxyApi + "/store/7bd87d-2/update_variant";

// Defensive reset/error helpers usable from every add-to-cart path. The
// per-flow local resetSubmitState()/showVariationError() are scoped inside
// their submit handlers, so these guards must not throw on pages where the
// matching elements don't exist (e.g. project-donation forms have no
// #donate-now button).

const resetSubmitStateSafe = () => {
  const submitButton = document.querySelector("#donate-now, #custom-donate-now");
  if (submitButton) {
    submitButton.removeAttribute("disabled");
    submitButton.removeAttribute("aria-disabled");
    submitButton.classList.remove("loading");
  }
  const spinner = document.querySelector(".loading-overlay__spinner");
  if (spinner) spinner.classList.add("hidden");
};

// 01.10.2026 (Ankit): pause + visible "processing" label between the
// create_variant API response and the first cart/add.js call.
//
// Why: Shopify's storefront cart index lags variant creation. Backend PR
// #331 (forceCartIndexRefresh) closes the window BEFORE the API responds,
// so a 200 from create_variant means the variant has been force-touched
// into the index. The 4s pause is a pure safety margin on top of that
// guarantee - the label keeps the customer from thinking the page froze.
//
// Implementation notes:
// - aria-live="polite" + role="status" so screen readers announce it.
// - Fixed position, high z-index: renders on any page without depending
//   on page-specific markup or CSS files (no stylesheet edit needed).
// - The button's own .loading spinner stays visible - the label sits
//   above it and says WHY we're waiting, not just THAT we're waiting.
// - Idempotent: reuses the same node if called twice (defensive).
const VARIANT_ADD_PROCESSING_LABEL_ID = "variant-add-processing-label";
const VARIANT_ADD_PROCESSING_DELAY_MS = 5000;

const showVariantAddProcessingLabel = () => {
  let el = document.getElementById(VARIANT_ADD_PROCESSING_LABEL_ID);
  if (el) return el;
  el = document.createElement("div");
  el.id = VARIANT_ADD_PROCESSING_LABEL_ID;
  el.setAttribute("role", "status");
  el.setAttribute("aria-live", "polite");
  // Inline styles: keep the diff to this file only (no CSS file edit).
  el.style.cssText =
    "position:fixed;left:50%;bottom:24px;transform:translateX(-50%);" +
    "z-index:2147483000;background:#111;color:#fff;padding:10px 18px;" +
    "border-radius:6px;font:14px/1.4 inherit;box-shadow:0 2px 12px rgba(0,0,0,.25);" +
    "pointer-events:none;";
  el.textContent = "Deine Spende wird vorbereitet – bitte kurz warten …";
  document.documentElement.appendChild(el);
  return el;
};

const hideVariantAddProcessingLabel = () => {
  const el = document.getElementById(VARIANT_ADD_PROCESSING_LABEL_ID);
  if (el) el.remove();
};

// Resolves after ~4s while the label is on screen. Awaited exactly once,
// immediately before the first cart/add.js call of every donation flow.
// If the waiting ever has to become conditional on an explicit backend
// "ready for cart" flag, this is the single place to change it - today
// no such field exists (see PR body for the backend's response shape).
const waitBeforeFirstCartAdd = async () => {
  const t0 = performance.now();
  console.log("[PAUSE-DEBUG] waitBeforeFirstCartAdd START", new Date().toISOString());
  showVariantAddProcessingLabel();
  await new Promise((resolve) =>
    setTimeout(resolve, VARIANT_ADD_PROCESSING_DELAY_MS)
  );
  hideVariantAddProcessingLabel();
  console.log("[PAUSE-DEBUG] waited", Math.round(performance.now() - t0) + "ms — expected", VARIANT_ADD_PROCESSING_DELAY_MS + "ms");
};

const showVariationErrorSafe = (message) => {
  document.querySelectorAll('[id="variation-error"]').forEach((el) => {
    if (!("originalHtml" in el.dataset)) {
      el.dataset.originalHtml = el.innerHTML;
    }
    if (message) {
      const small = el.querySelector("small");
      if (small) {
        small.textContent = message;
      } else {
        el.textContent = message;
      }
    }
    el.style.display = "block";
  });
};

function validateInputs() {
  const activeTabName = [...document.querySelectorAll(".tab")]
    .find((tab) => tab.classList.contains("active"))
    .getAttribute("data-tab-name");
  var tabForMe = activeTabName == "for-me";
  var digitalEmailVersionCheckbox = document.getElementById(
    "digital-email-version-checkbox"
  ).checked;
  var calendarType = document.getElementById("calendar-type").value;
  var calendarTypePaper = calendarType == "Papierkalender";
  var calendarTypeDigital = calendarType == "Digitaler Kalender";

  var tabAsGift = activeTabName == "as-gift";
  var giftCalendarType = document.getElementById("gift-calendar-type").value;
  var giftCalendarTypePaper = giftCalendarType == "Papierkalender";
  var giftCalendarTypeDigital = giftCalendarType == "Digitaler Kalender";

  $.validator.addMethod(
    "euroMin",
    function (value, element, param) {
      // Convert the European-style number (comma as decimal separator) to a dot
      let numericValue = parseFloat(value.replace(",", "."));

      // Check if the numeric value is greater than or equal to the specified minimum
      return this.optional(element) || numericValue >= param;
    },
    "Bitte beachte die Mindestspende von {0}€ pro Projekt."
  );

  $("#product-page-form").validate({
    rules: {
      // tab for me - paper
      email: {
        required: function () {
          return tabForMe && calendarTypePaper && digitalEmailVersionCheckbox;
        },
        email: function () {
          return tabForMe && calendarTypePaper && digitalEmailVersionCheckbox;
        },
      },
      donationAmount: {
        required: function () {
          return tabForMe && calendarTypePaper;
        },
        euroMin: 1,
      },
      shippingDate: {
        required: function () {
          return tabForMe && calendarTypePaper;
        },
      },
      // tab for me - digital
      digitalDonationAmount: {
        required: function () {
          return tabForMe && calendarTypeDigital;
        },
        euroMin: 1,
      },
      // tab as-gift - paper
      giftDonationAmount: {
        required: function () {
          return tabAsGift && giftCalendarTypePaper;
        },
        euroMin: 1,
      },
      giftShippingDate: {
        required: function () {
          return tabAsGift && giftCalendarTypePaper;
        },
      },
      shippingAddress: {
        required: function () {
          return tabAsGift && giftCalendarTypePaper;
        },
      },
      ShippingAddressForMe: {
        required: function () {
          return !tabAsGift && giftCalendarTypePaper;
        },
      },
      // tab as-gift - digital
      giftDigitalDonationAmount: {
        required: function () {
          return tabAsGift && giftCalendarTypeDigital;
        },
        euroMin: 1,
      },
      digitalGreetingText: {
        required: function () {
          return tabAsGift && giftCalendarTypeDigital;
        },
      },
      giftYourName: {
        required: function () {
          return tabAsGift && giftCalendarTypeDigital;
        },
      },
      giftDigitalEmail: {
        required: function () {
          return tabAsGift && giftCalendarTypeDigital;
        },
        email: function () {
          return tabAsGift && giftCalendarTypeDigital;
        },
      },
    },
    messages: {
      email: {
        required: "Bitte gib eine korrekte E-Mail-Adresse ein!",
        email: "Bitte gib eine korrekte E-Mail-Adresse ein!",
      },
      donationAmount: {
        required: "Bitte wähle einen Spendenbetrag!",
        min: "Bitte beachte die Mindestspende von 1€ pro Projekt.",
      },
      digitalDonationAmount: {
        required: "Bitte wähle einen Spendenbetrag!",
        min: "Bitte beachte die Mindestspende von 1€ pro Projekt.",
      },
      giftDonationAmount: {
        required: "Bitte wähle einen Spendenbetrag!",
        min: "Bitte beachte die Mindestspende von 1€ pro Projekt.",
      },
      giftDigitalDonationAmount: {
        required: "Bitte wähle einen Spendenbetrag!",
        min: "Bitte beachte die Mindestspende von 1€ pro Projekt.",
      },
      shippingDate: {
        required: "Bitte wähle ein Versanddatum!",
      },
      giftShippingDate: {
        required: "Bitte wähle ein Versanddatum!",
      },
      shippingAddress: {
        required:
          "Bitte gib die vollständige Adresse der beschenkten Person ein!",
      },
      ShippingAddressForMe: {
        required:
          "Bitte gib die vollständige Adresse der beschenkten Person ein!",
      },
      giftDigitalEmail: {
        required: "Bitte gib eine korrekte Email-Adresse ein!”",
        email: "Bitte gib eine korrekte Email-Adresse ein!”",
      },
      digitalGreetingText: {
        required: "Bitte gib einen Grußtext ein!",
      },
      giftYourName: {
        required: "Bitte gib deinen Namen ein!",
      },
    },
    errorClass: "error-validate",
    submitHandler: function () {},
  });

  $("#product-page-form").submit();
  return $("#product-page-form").valid();
}

let donateNow = () => {
  const isValid = validateInputs();
  if (!isValid) return;

  const urlParams = new URLSearchParams(window.location.search);
  const editMode = urlParams.get("edit");
  const variantId = urlParams.get("variant");

  if (editMode === "true" && variantId) {
    updateCartItem(variantId);
    return;
  }

  let ProductForType = "";
  const activeTabName = [...document.querySelectorAll(".tab")]
    .find((tab) => tab.classList.contains("active"))
    .getAttribute("data-tab-name");

  if (activeTabName == "for-me") {
    var quantity = document.querySelector("#amount-input").value;
  } else {
    var quantity = document.querySelector("#gift-amount-input").value;
  }

  let product_id = document.querySelector("input[name='product-id']").value;
  const calendarTypeSelector =
    activeTabName === "for-me" ? "calendar-type" : "gift-calendar-type";
  const languageSelector =
    activeTabName === "for-me" ? "language" : "gift-language";

  const calendarType = document.getElementById(calendarTypeSelector).value;
  const language = document.getElementById(languageSelector).value;

  var address = "";
  var addressObj = "";
  if (calendarType == "Papierkalender") {
    if (activeTabName == "for-me") {
      var address = document.getElementById("shipping_address_for_me").value;
      var addressObj = document.getElementById("shipping_address_for_me_json").value;

      // var form2 = document.getElementById("info-form");
      // var formData2 = new FormData(form2);

      // var addressDataObj = {};
      // formData2.forEach((value, key) => {
      //   addressDataObj[key] = value;
      // });
      // var addressObj = JSON.stringify(addressDataObj);
    } else {
      var address = document.getElementById("shipping_address").value;
      var addressObj = document.getElementById("shipping_address_json").value;

      // var form2 = document.getElementById("info-form");
      // var formData2 = new FormData(form2);

      // var addressDataObj = {};
      // formData2.forEach((value, key) => {
      //   addressDataObj[key] = value;
      // });
      // var addressObj = JSON.stringify(addressDataObj);
    }
  }

  // Null-safe cost reader (checkout-freeze fix): the price-summary spans are only
  // rendered by calculateTotal() after the address popup was saved via "Speichern".
  // Reading them unguarded crashed the Warenkorb handler silently when the
  // customer filled the address but never saved it.
  var readCostFromElement = function (elementId) {
    var el = document.getElementById(elementId);
    if (!el) return "";
    var match = el.textContent.match(/\d+([,\.]\d+)?/);
    return match ? match[0].replace(",", ".") : "";
  };

  var shippingCost = "";
  if (calendarType == "Papierkalender") {
    if (activeTabName == "for-me") {
      var shippingCost = readCostFromElement("for-me-paper__shipping_cost");
    } else {
      var shippingCost = readCostFromElement("as-gift-paper__shipping_cost");
    }
  }

  var cardDesignCost = "";
  if (calendarType == "Papierkalender" && activeTabName == "as-gift") {
    // var cardDesignCost = document
    //   .getElementById("as-gift-paper__card_design")
    //   .textContent.match(/\d+([,\.]\d+)?/)[0]
    //   .replace(",", ".");
    var el = document.getElementById("as-gift-paper__card_design");

    if (el) {
      var match = el.textContent.match(/\d+([,\.]\d+)?/);
      if (match) {
        cardDesignCost = match[0].replace(",", ".");
      }
    }
  }

  var implementationCost = "";
  if (calendarType == "Digitaler Kalender") {
    var implementationCost = readCostFromElement("digital__implementation_cost");
  }

  var email = "";
  var greetingText = "";
  var shippingDate = null;
  var digitalReceiverName = "";
  var donationAmount = 0;
  let amount = 0;
  if (activeTabName == "for-me") {
    if (calendarType == "Papierkalender") {
      ProductForType = "for-me";
      shippingDate = document.getElementById("shipping-date").value;
      email = document.getElementById("email-input").value;
      donationAmount = document.querySelector("#donation-amount").value;
      amount = document
        .getElementById("for-me-paper__amount")
        .textContent.match(/\d+([,\.]\d+)?/)[0]
        .replace(",", ".");
    } else {
      amount = document
        .getElementById("for-me-digital__amount")
        .textContent.match(/\d+([,\.]\d+)?/)[0]
        .replace(",", ".");
      donationAmount = document.querySelector("#digital-donation-amount").value;
    }
  } else {
    if (calendarType == "Papierkalender") {
      ProductForType = "as-gift";
      shippingDate = document.getElementById("gift-shipping-date").value;

      const recipientImageInput = document.getElementById(
        "recipient-greeting-image"
      );
      const recipientImageFile = recipientImageInput.files[0];
      if (
        !recipientImageFile &&
        typeof window.createDefaultCanvas === "function"
      ) {
        window.createDefaultCanvas();
      }
      donationAmount = document.querySelector("#gift-donation-amount").value;
      amount = document
        .getElementById("as-gift-paper__amount")
        .textContent.match(/\d+([,\.]\d+)?/)[0]
        .replace(",", ".");
    } else {
      email = document.getElementById("gift-digital-email-input").value;
      var greetingText = document
        .getElementById("digital-greeting-text")
        .value.replace(/\n/g, "\r\n");
      var digitalReceiverName = document.getElementById("gift-your-name").value;
      donationAmount = document.querySelector(
        "#gift-digital-donation-amount"
      ).value;
      amount = document
        .getElementById("as-gift-digital__amount")
        .textContent.match(/\d+([,\.]\d+)?/)[0]
        .replace(",", ".");
    }
  }

  // Prevent comma at the end
  if (donationAmount.endsWith(",")) {
    donationAmount = donationAmount.slice(0, -1);
  }
  donationAmount = donationAmount.replace(/[^0-9,]/g, "").replace(",", ".");

  const errorElement = document.getElementById("variation-error");
  errorElement.style.display = "none";

  // Show a (optionally specific) message in every variation-error element.
  // Keeps the original markup (e.g. styled <small> children) intact:
  // - first use stores each element's original innerHTML
  // - a specific message goes into an existing <small> child if present,
  //   otherwise into the element's textContent (never injected as HTML)
  // - without a specific message the stored original markup is restored
  const showVariationError = (message) => {
    document.querySelectorAll('[id="variation-error"]').forEach((el) => {
      if (!("originalHtml" in el.dataset)) {
        el.dataset.originalHtml = el.innerHTML;
      }
      if (message) {
        const small = el.querySelector("small");
        if (small) {
          small.textContent = message;
        } else {
          el.textContent = message;
        }
      } else if (el.dataset.originalHtml) {
        el.innerHTML = el.dataset.originalHtml;
      }
      el.style.display = "block";
    });
  };

  // Prevent creating a variant with a zero/invalid amount
  const parsedAmount = Number(amount);
  if (!Number.isFinite(parsedAmount) || parsedAmount <= 0) {
    showVariationError("Der Spendenbetrag muss größer als 0 sein.");
    return;
  }

  const submitButton = document.querySelector("#donate-now");
  const cartNotification = document.querySelector("cart-notification");

  // Restore the submit button and hide the loading spinner so the user
  // can retry after an error was shown.
  const resetSubmitState = () => {
    submitButton.removeAttribute("disabled");
    submitButton.removeAttribute("aria-disabled");
    submitButton.classList.remove("loading");
    document
      .querySelector(".loading-overlay__spinner")
      .classList.add("hidden");
  };

  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  document
    .querySelector(".loading-overlay__spinner")
    .classList.remove("hidden");

  const body = JSON.stringify({
    donationAmount: `${donationAmount}`,
    price: `${amount}`,
    product_id: `${product_id}`,
    title: `Spendenbetrag ${amount}`,
    // ProductType: ProductForType,
    ProductType: activeTabName,
    CalendarType: calendarType,
    quantity: quantity,
  });
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  };

  // Make the POST request
  fetch(createVariantUrl, options)
    .then((response) => {
      if (!response.ok) {
        // Try to surface a relatable error message from the response body
        return response
          .json()
          .catch(() => null)
          .then((data) => {
            // 429 rate limit ("too_many_requests"): give the customer the
            // backend's cooldown message verbatim (already user-facing
            // German: "Bitte versuche es in ein paar Minuten erneut") and
            // do NOT auto-retry — each attempt extends the block.
            const message =
              data && data.error ? data.error : null;
            resetSubmitState();
            showVariationError(message);
            throw new Error(message || "Network response was not ok");
          });
      }
      return response.json();
    })
    .then(async (data) => {
      // Backend (#331) has already force-indexed the variant; 4s label +
      // pause (see waitBeforeFirstCartAdd) is a safety margin on top.
      console.log("waitBeforeFirstCartAdd start");
      await waitBeforeFirstCartAdd();
      // adding product to cart
      let atc = () => {
        let variant_id = data.variant.id;
        const recipientTextInput = document.getElementById(
          "recipient-greeting-text"
        ).value;
        const imagePreview = document.getElementById("image-preview").value;
        const recipientImageInput = document.getElementById(
          "recipient-greeting-image"
        );
        const recipientImageFile = recipientImageInput.files[0];
        // const recipientGreetingImageJson = document.getElementById(
        //   "recipient-greeting-image-json"
        // ).value;

        const formData = new FormData();
        formData.append("id", variant_id);
        formData.append("quantity", 1);
        formData.append(
          "sections",
          cartNotification.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        formData.append("key", variant_id);

        if (activeTabName == "for-me" || activeTabName == "as-gift") {
          formData.append(
            "properties[Art]",
            activeTabName == "for-me" ? "Für mich" : "Als Geschenk"
          );
        }
        formData.append("properties[Typ]", calendarType);
        formData.append("properties[Sprache]", language);

        if (quantity.trim() !== "") {
          formData.append("properties[Anzahl]", parseInt(quantity));
        }
        if (email.trim() !== "") {
          formData.append("properties[Email-Adresse]", email);
        }
        if (shippingDate) {
          formData.append("properties[Versanddatum]", shippingDate);
        }
        if (greetingText.trim() !== "") {
          formData.append("properties[Grußtext]", greetingText);
        }
        if (digitalReceiverName.trim() !== "") {
          formData.append(
            "properties[_DigitalReceiverName]",
            digitalReceiverName
          );
        }

        if (shippingCost.trim() !== "") {
          formData.append("properties[_ShippingCost]", shippingCost);
        }
        if (cardDesignCost.trim() !== "") {
          formData.append("properties[_CardDesignCost]", cardDesignCost);
        }
        if (implementationCost.trim() !== "") {
          formData.append(
            "properties[_ImplementationCost]",
            implementationCost
          );
        }
        formData.append("properties[Lieferadresse]", address);
        formData.append("properties[_LieferadresseJson]", addressObj);
        formData.append("properties[_ProductForType]", activeTabName);

        if (recipientImageFile) {
          if (imagePreview.length > 0) {
            formData.append("properties[_Grußkarte]", recipientImageFile);
            // formData.append(
            //   "properties[_GrußkarteJson]",
            //   recipientGreetingImageJson
            // );
          } else {
            formData.append("properties[Grußtext]", recipientTextInput);
          }
        }

        formData.append("properties[_Spenden_Betrag]", donationAmount);

        let formDataTmp = {
          items: [
            {
              id: variant_id,
              quantity: 1,
              properties: {
                ProductForType: activeTabName,
                Typ: calendarType,
                Sprache: language,
                ...(quantity.trim() !== "" && {
                  Anzahl: parseInt(quantity),
                }),
                ...(email.trim() !== "" && { Email: email }),
                ...(shippingDate && {
                  Versanddatum: shippingDate,
                }),
                ...(greetingText.trim() !== "" && {
                  Grußtext: greetingText,
                }),
                Lieferadresse: address,
              },
            },
          ],
          sections: cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
          key: variant_id,
        };

        addToCartWithRetry(formData, async (response) => {
          if (localStorage.getItem("cartData")) {
            let cartItems = JSON.parse(localStorage.getItem("cartData"));
            let newItem = formDataTmp["items"][0];
            newItem.img = document.querySelector("product-media img").src;
            newItem.price = amount;
            newItem.title =
              document.querySelector(".product-title").textContent;
            newItem.handle = location.href;
            cartItems.unshift(newItem);
            localStorage.setItem("cartData", JSON.stringify(cartItems));
          } else {
            let newItem = formDataTmp["items"][0];
            newItem.img = document.querySelector("product-media img").src;
            newItem.img = document.querySelector("product-media img").src;
            newItem.price = amount;
            newItem.title =
              document.querySelector(".product-title").textContent;
            newItem.handle = location.href;
            localStorage.setItem("cartData", JSON.stringify([newItem]));
          }

          checkCartPrice(response.id);
        });
      };
      atc();
    })
    .catch((error) => {
      resetSubmitState();
      console.error("Error:", error);
    });
};

// Add to cart with retry on 422 "Kann Variante nicht finden" — right after
// create_variant, the storefront cart API can briefly reject a variant the
// Admin API already returned (propagation race). Retry with backoff instead
// of parsing the error body as success (response.id === undefined used to
// feed checkCartPrice(undefined) -> infinite spinner).
const ADD_TO_CART_RETRY_DELAYS_MS = [500, 1000, 2000, 4000, 4000, 6000, 8000];

const addToCartWithRetry = async (formData, onAdded) => {
  for (let attempt = 0; ; attempt++) {
    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    });
    const parsed = await response.json().catch(() => null);
    if (response.ok && parsed && typeof parsed.id !== "undefined") {
      if (onAdded) await onAdded(parsed);
      return parsed;
    }
    const description = parsed && parsed.description ? parsed.description : "";
    console.warn(
      "cart/add.js attempt " + (attempt + 1) + " failed: HTTP " +
        response.status + (description ? " - " + description : "")
    );
    // 429/423 "too many attempts": the storefront is rate-limiting this
    // visitor. Retrying against a rate limit EXTENDS the block — abort the
    // loop immediately and tell the customer when to come back. The block
    // is per visitor/IP, not per variant, so a different variant or page
    // would hit the same wall.
    if (response.status === 429 || response.status === 423) {
      resetSubmitStateSafe();
      showVariationErrorSafe(
        "Zu viele Versuche. Bitte warte ein paar Minuten und versuche es dann erneut."
      );
      return undefined;
    }
    // 422 after a create_variant is usually the admin->cart propagation
    // race: retrying makes sense (delays below). The backend now force-
    // indexes new variants (#331), so a 422 that survives the retry window
    // is a hard error — stop and let the customer retry manually.
    if (attempt >= ADD_TO_CART_RETRY_DELAYS_MS.length) {
      resetSubmitStateSafe();
      showVariationErrorSafe(
        "Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut."
      );
      // 30.09.2026 hotfix: return undefined instead of throwing — the
      // uncaught error killed caller code after the guards already ran
      // (console: "Uncaught (in promise) Error: cart/add.js failed after
      // retries"). Callers treat a falsy result as "not added" and stop.
      return undefined;
    }
    await new Promise((resolve) =>
      setTimeout(resolve, ADD_TO_CART_RETRY_DELAYS_MS[attempt])
    );
  }
};

async function checkCartPrice(cartId, attempt = 0) {
  // No cart line id (add.js failed upstream) or polling budget exhausted
  // (30 x 500ms = 15s): stop instead of spinning forever
  // ("Warenkorb lädt nicht" freeze).
  if (
    typeof cartId === "undefined" ||
    cartId === null ||
    attempt >= 30
  ) {
    resetSubmitStateSafe();
    showVariationErrorSafe(
      "Der Warenkorb konnte nicht geladen werden. Bitte versuche es erneut."
    );
    return;
  }
  await fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => response.json())
    .then(async (data) => {
      const item = data.items.find((item) => item.id == cartId);
      console.log("Checking item :: ", item);

      if (item && item.price != 0) {
        // Price is not 0, redirect to cart
        const lang = window.location.pathname.split("/")[1];
        if (lang == "en") {
          location.href = "/en/cart";
        } else {
          location.href = "/cart";
        }
      } else {
        // Price is 0, proceed as needed or keep checking
        // Call check again after short delay
        setTimeout(async () => await checkCartPrice(cartId, attempt + 1), 500); // check again after 500ms
      }
    })
    .catch((error) => {
      console.error("Cart contents Error:", error);
      resetSubmitStateSafe();
      showVariationErrorSafe(
        "Der Warenkorb konnte nicht geladen werden. Bitte versuche es erneut."
      );
    });
}

let deleteVariant = (product_id, variant_id) => {
  const url = proxyApi + "/store/7bd87d-2/delete_variant";
  // const url = "https://shopify.codieslab.com/api/store/7bd87d-2/delete_variant";
  const body = JSON.stringify({
    product_id: `${product_id}`,
    variant_id: `${variant_id}`,
  });
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  };

  fetch(url, options)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      /* Cart Update Code Start */
      var dataArray;
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((data) => {
          const convertedItems = data.items.map((item1) => ({
            [item1.id]: item1.quantity,
          }));
          dataArray = convertedItems;
        })
        .catch((error) => {
          console.error("Cart contents Error:", error);
        });

      fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dataArray }),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
      /* Cart Update Code End */

      return response.json();
    })
    .catch((error) => {
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
    });
};

$(function () {
  const digitalGreetingTextEditor = document.querySelector(
    "#digital-greeting-text"
  );
  if (digitalGreetingTextEditor) {
    digitalGreetingTextEditor.addEventListener("input", function () {
      const maxLength = 300;
      if (digitalGreetingTextEditor.value.length > maxLength) {
        digitalGreetingTextEditor.value =
          digitalGreetingTextEditor.value.substring(0, maxLength);
      }
      const lineBreaks = (digitalGreetingTextEditor.value.match(/\n/g) || [])
        .length;
      const maxLineBreaks = 5;
      // If line breaks exceed the maximum allowed, remove the extra line breaks
      if (lineBreaks > maxLineBreaks) {
        digitalGreetingTextEditor.value =
          digitalGreetingTextEditor.value.replace(
            /\n/g,
            (match, offset, string) => {
              return (string.slice(0, offset).match(/\n/g) || []).length <
                maxLineBreaks
                ? match
                : "";
            }
          );
      }
    });
  }
});

function validateCustomDonationInputs() {
  const minMessage = document.querySelector(
    "input[name='customDonationAmount']"
  ).dataset.minMessage;
  const requiredMessage = document.querySelector(
    "input[name='customDonationAmount']"
  ).dataset.requiredMessage;

  $("#custom-product-form").validate({
    rules: {
      customDonationAmount: {
        required: true,
        min: 5,
      },
    },
    messages: {
      customDonationAmount: {
        required: requiredMessage,
        min: minMessage,
      },
    },
    errorClass: "error-validate",
    submitHandler: function () {},
  });

  $("#custom-product-form").submit();
  return $("#custom-product-form").valid();
}

let customDonateNow = () => {
  const isValid = validateCustomDonationInputs();
  if (!isValid) return;

  const productForType = "custom-donation";
  const productId = document.querySelector("input[name='product-id']").value;
  const projectPageId = document.querySelector(
    "input[name='project-page-id']"
  ).value;
  const donationCartTitle =
    document.querySelector("input[name='donation-cart-title']")?.value ?? null;
  const donationCartImage =
    document.getElementById("donation-cart-image")?.src ?? null;
  const customDonationAmount = document.querySelector(
    "input[name='customDonationAmount']"
  ).value;
  const donationProjectTag =
    document.querySelector("input[name='project-donation-tag']")?.value ?? null;
  const donationArticleHandle =
    document.querySelector("input[name='article-handle']")?.value ?? null;

  const submitButton = document.querySelector("#custom-donate-now");
  const cartNotification = document.querySelector("cart-notification");
  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  document
    .querySelector(".loading-overlay__spinner")
    .classList.remove("hidden");

  const body = JSON.stringify({
    donationAmount: `${customDonationAmount}`,
    price: `${customDonationAmount}`,
    product_id: `${productId}`,
    title: `Spendenbetrag ${customDonationAmount}`,
    ProductType: `${productForType}`,
    donationArticleHandle: `${donationArticleHandle}`,
    quantity: 1,
  });
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  };

  // Make the POST request
  fetch(createVariantUrl, options)
    .then((response) => {
      if (!response.ok) {
        errorElement.style.display = "block";
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(async (data) => {
      // Safety margin on top of backend #331 force-indexing, with label.
      await waitBeforeFirstCartAdd();
      let variant_id = data.variant.id;

      const formData = new FormData();
      formData.append("id", variant_id);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        cartNotification.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      formData.append("key", variant_id);
      formData.append("properties[_ProductForType]", productForType);
      formData.append("properties[_ProjectPageId]", projectPageId);
      if (donationCartTitle) {
        formData.append("properties[_DonationCartTitle]", donationCartTitle);
      }
      if (donationCartImage) {
        formData.append("properties[_DonationCartImage]", donationCartImage);
      }
      if (donationProjectTag) {
        formData.append("properties[_DonationProjectTag]", donationProjectTag);
      }
      if (donationArticleHandle) {
        formData.append(
          "properties[_DonationArticleHandle]",
          donationArticleHandle
        );
      }

      let formDataTmp = {
        items: [
          {
            id: variant_id,
            quantity: 1,
            properties: {
              ProductForType: productForType,
              _ProjectPageId: projectPageId,
              ...(donationCartTitle
                ? { _DonationCartTitle: donationCartTitle }
                : {}),
              ...(donationCartImage
                ? { _DonationCartImage: donationCartImage }
                : {}),
              ...(donationProjectTag
                ? { _DonationProjectTag: donationProjectTag }
                : {}),
            },
          },
        ],
        sections: cartNotification
          .getSectionsToRender()
          .map((section) => section.id),
        sections_url: window.location.pathname,
        key: variant_id,
      };

      await addToCartWithRetry(formData, async (response) => {
        if (localStorage.getItem("cartData")) {
          let cartItems = JSON.parse(localStorage.getItem("cartData"));
          let newItem = formDataTmp["items"][0];
          donationCartImage && (newItem.img = donationCartImage);
          donationCartTitle && (newItem.title = donationCartTitle);
          newItem.price = customDonationAmount;
          newItem.handle = location.href;
          cartItems.unshift(newItem);
          localStorage.setItem("cartData", JSON.stringify(cartItems));
        } else {
          let newItem = formDataTmp["items"][0];
          donationCartImage && (newItem.img = donationCartImage);
          donationCartTitle && (newItem.title = donationCartTitle);
          newItem.price = customDonationAmount;
          newItem.handle = location.href;
          localStorage.setItem("cartData", JSON.stringify([newItem]));
        }

        // location.href = "/cart";
        await checkCartPrice(response.id);
      });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

$(document).on("focusout", "#project-donation-amount", function () {
  $.validator.addMethod(
    "euroMin",
    function (value, element, param) {
      let numericValue = parseFloat(value.replace(",", "."));
      return this.optional(element) || numericValue >= param;
    },
    "Bitte beachte die Mindestspende von {0}€ pro Projekt."
  );

  $("#project-page-form").validate({
    rules: {
      projectDonationAmount: {
        required: true,
        euroMin: 10,
      },
    },
    messages: {
      projectDonationAmount: {
        required: "Bitte wähle einen Spendenbetrag!",
      },
    },
    errorClass: "error-validate",
    submitHandler: function () {},
  });

  return $("#project-page-form").valid();
});

function validateInputProjectDonate() {
  $("#project-page-form").validate().destroy();
  const checkbox = document.getElementById("print-out-christmas-card").checked;

  $.validator.addMethod(
    "euroMin",
    function (value, element, param) {
      let numericValue = parseFloat(value.replace(",", "."));
      return this.optional(element) || numericValue >= param;
    },
    "Bitte beachte die Mindestspende von {0}€ pro Projekt."
  );

  $("#project-page-form").validate({
    rules: {
      projectDonationAmount: {
        required: true,
        euroMin: 10,
      },
      shippingAddress: {
        required: function () {
          return !checkbox;
        },
      },
      shippingDate: {
        required: function () {
          return !checkbox;
        },
      },
      emailChristmasCard: {
        required: function () {
          return checkbox;
        },
        email: function () {
          return checkbox;
        },
      },
    },
    messages: {
      projectDonationAmount: {
        required: "Bitte wähle einen Spendenbetrag!",
      },
      shippingAddress: {
        required:
          "Bitte gib die vollständige Adresse der beschenkten Person ein!",
      },
      emailChristmasCard: {
        required: "Bitte gib eine korrekte E-Mail-Adresse ein!",
        email: "Bitte gib eine korrekte E-Mail-Adresse ein!",
      },
    },
    errorClass: "error-validate",
    submitHandler: function () {},
  });

  $("#project-page-form").submit();
  return $("#project-page-form").valid();
}

let customProductDonateNow = () => {
  const isValid = validateInputProjectDonate();
  if (!isValid) return;

  const errorElement = document.getElementById("variation-error");
  errorElement.style.display = "none";

  const donationCartTitle =
    document.querySelector("input[name='donation-cart-title']")?.value ?? null;
  const productForType = document.querySelector(
    "input[name='product-type']"
  ).value;
  const sammelaktionGreetingCardId =
    document.querySelector("input[name='sammelaktion-greeting-card-id']")
      ?.value ?? null;
  const effectiveProductForType = sammelaktionGreetingCardId
    ? sammelaktionGreetingCardId
    : productForType;
  const product_id = document.querySelector("input[name='product-id']").value;
  const sammelaktionId =
    document.querySelector("input[name='sammelaktion-id']")?.value ?? null;

  const amount = document
    .getElementById("project-total-amount")
    .textContent.match(/\d+([,\.]\d+)?/)[0]
    .replace(",", ".");
  const processingCost = document
    .getElementById("project-processing-cost")
    .textContent.match(/\d+([,\.]\d+)?/)[0]
    .replace(",", ".");

  const checkboxPrintOut = document.getElementById(
    "print-out-christmas-card"
  ).checked;
  var email = null;
  var address = null;
  var addressObj = null;
  var shippingCost = 0;
  var shippingDate = null;
  if (checkboxPrintOut) {
    email = document.getElementById("email-christmas-card").value;
  } else {
    address = document.getElementById("shipping_address").value;
    const infoForm = document.getElementById("info-form");
    const infoFormData = new FormData(infoForm);
    let addressDataObj = {};
    infoFormData.forEach((value, key) => {
      addressDataObj[key] = value;
    });
    addressObj = JSON.stringify(addressDataObj);

    shippingCost = document
      .getElementById("project-shipping-cost")
      .textContent.match(/\d+([,\.]\d+)?/)[0]
      .replace(",", ".");
    shippingDate = document.getElementById("shipping-date").value;
  }

  var greetingText = document
    .getElementById("project-greeting-text")
    .value.replace(/\n/g, "\r\n");

  const donationProjectTag =
    document.querySelector("input[name='project-donation-tag']").value ?? null;

  var donationAmount = document.querySelector("#project-donation-amount").value;
  if (donationAmount.endsWith(",")) {
    donationAmount = donationAmount.slice(0, -1);
  }
  donationAmount = donationAmount.replace(/[^0-9,]/g, "").replace(",", ".");
  const quantity = document.getElementById("amount-input").value;
  const submitButton = document.querySelector("#project-donate-now");
  const cartNotification = document.querySelector("cart-notification");
  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  document
    .querySelector(".loading-overlay__spinner")
    .classList.remove("hidden");

  const body = JSON.stringify({
    donationAmount: `${donationAmount}`,
    price: `${amount}`,
    product_id: `${product_id}`,
    title: `Spendenbetrag ${amount}`,
    ProductType: effectiveProductForType,
    Sammelaktion: sammelaktionId,
    quantity: 1,
  });
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  };

  // Make the POST request
  fetch(createVariantUrl, options)
    .then((response) => {
      if (!response.ok) {
        errorElement.style.display = "block";
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(async (data) => {
      // Safety margin on top of backend #331 force-indexing, with label.
      await waitBeforeFirstCartAdd();
      // adding product to cart
      let atc = async () => {
        let variant_id = data.variant.id;
        const recipientCardInput = document.getElementById(
          "recipient-greeting-card"
        );
        const recipientCardFile = recipientCardInput.files[0];

        const formData = new FormData();
        formData.append("id", variant_id);
        formData.append("quantity", 1);
        formData.append(
          "sections",
          cartNotification.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        formData.append("key", variant_id);
        formData.append("properties[Anzahl]", parseInt(quantity));

        if (recipientCardFile) {
          formData.append("properties[_Grußkarte]", recipientCardFile);
        } else if (greetingText.trim() !== "") {
          formData.append("properties[Grußtext]", greetingText);
        }

        // Bei Sammelaktion-Grußkarten ist sammelaktion-greeting-card-id gesetzt (siehe
        // initSammelaktionData()) und hat Vorrang vor productForType: sie trägt den
        // fundraising_greeting_card_hash der Grußkarte, der die Karte eindeutig
        // identifiziert (siehe PDFUtil::createSammelaktionCard).
        formData.append("properties[_ProductForType]", effectiveProductForType);
        formData.append("properties[_Spenden_Betrag]", donationAmount);
        formData.append("properties[_DonationProjectTag]", donationProjectTag);
        formData.append("properties[_DonationCartTitle]", donationCartTitle);
        formData.append("properties[_ProcessingCost]", processingCost);

        if (checkboxPrintOut) {
          formData.append("properties[Email-Adresse]", email);
        } else {
          formData.append("properties[Lieferadresse]", address);
          formData.append("properties[_LieferadresseJson]", addressObj);
          formData.append("properties[_ShippingCost]", shippingCost);
          formData.append("properties[Versanddatum]", shippingDate);
        }

        if (sammelaktionId) {
          formData.append("properties[_Sammelaktion]", sammelaktionId);
        }

        const donationCartImage = document.getElementById(
          "donation-cart-image"
        ).src;

        let formDataTmp = {
          items: [
            {
              id: variant_id,
              quantity: 1,
              properties: {
                ProductForType: effectiveProductForType,
                Anzahl: 1,
                ...(greetingText.trim() !== "" && {
                  Grußtext: greetingText,
                }),
                ...(address && {
                  Lieferadresse: address,
                }),
                ...(email && {
                  Email: email,
                }),
                ...(shippingDate && {
                  Versanddatum: shippingDate,
                }),
                _DonationProjectTag: donationProjectTag,
                _DonationCartTitle: donationCartTitle,
                _DonationCartImage: donationCartImage,
                ...(sammelaktionId && {
                  Sammelaktion: sammelaktionId,
                }),
              },
            },
          ],
          sections: cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
          key: variant_id,
        };

        await addToCartWithRetry(formData, async (response) => {
          if (localStorage.getItem("cartData")) {
            let cartItems = JSON.parse(localStorage.getItem("cartData"));
            let newItem = formDataTmp["items"][0];
            newItem.price = amount;
            donationCartTitle && (newItem.title = donationCartTitle);
            newItem.handle = location.href;
            cartItems.unshift(newItem);
            localStorage.setItem("cartData", JSON.stringify(cartItems));
          } else {
            let newItem = formDataTmp["items"][0];
            newItem.price = amount;
            donationCartTitle && (newItem.title = donationCartTitle);
            newItem.handle = location.href;
            localStorage.setItem("cartData", JSON.stringify([newItem]));
          }

          // location.href = "/cart";
          await checkCartPrice(response.id);
        });
      };
      await atc();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

let projectDonateNow = () => {
  const isValid = validateInputProjectDonate();
  if (!isValid) return;

  const errorElement = document.getElementById("variation-error");
  errorElement.style.display = "none";

  const donationCartTitle = "Die 24 GUTE TATEN Weihnachtskarte";
  const productForType = "christmas-card";
  const product_id = document.querySelector("input[name='product-id']").value;

  const amount = document
    .getElementById("project-total-amount")
    .textContent.match(/\d+([,\.]\d+)?/)[0]
    .replace(",", ".");
  const processingCost = document
    .getElementById("project-processing-cost")
    .textContent.match(/\d+([,\.]\d+)?/)[0]
    .replace(",", ".");

  const checkboxPrintOut = document.getElementById(
    "print-out-christmas-card"
  ).checked;
  var email = null;
  var address = null;
  var addressObj = null;
  var shippingCost = 0;
  if (checkboxPrintOut) {
    email = document.getElementById("email-christmas-card").value;
  } else {
    address = document.getElementById("shipping_address").value;
    const infoForm = document.getElementById("info-form");
    const infoFormData = new FormData(infoForm);
    let addressDataObj = {};
    infoFormData.forEach((value, key) => {
      addressDataObj[key] = value;
    });
    addressObj = JSON.stringify(addressDataObj);

    shippingCost = document
      .getElementById("project-shipping-cost")
      .textContent.match(/\d+([,\.]\d+)?/)[0]
      .replace(",", ".");
  }

  var greetingText = document
    .getElementById("project-greeting-text")
    .value.replace(/\n/g, "\r\n");

  const donationProjectTag =
    document.querySelector("input[name='project-donation-tag']").value ?? null;

  var donationAmount = document.querySelector("#project-donation-amount").value;
  if (donationAmount.endsWith(",")) {
    donationAmount = donationAmount.slice(0, -1);
  }
  donationAmount = donationAmount.replace(/[^0-9,]/g, "").replace(",", ".");

  const submitButton = document.querySelector("#project-donate-now");
  const cartNotification = document.querySelector("cart-notification");
  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  document
    .querySelector(".loading-overlay__spinner")
    .classList.remove("hidden");

  const body = JSON.stringify({
    donationAmount: `${donationAmount}`,
    price: `${amount}`,
    product_id: `${product_id}`,
    title: `Spendenbetrag ${amount}`,
    ProductType: productForType,
    quantity: 1,
  });
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  };

  // Make the POST request
  fetch(createVariantUrl, options)
    .then((response) => {
      if (!response.ok) {
        errorElement.style.display = "block";
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(async (data) => {
      // Safety margin on top of backend #331 force-indexing, with label.
      await waitBeforeFirstCartAdd();
      // adding product to cart
      let atc = async () => {
        let variant_id = data.variant.id;
        const formData = new FormData();
        formData.append("id", variant_id);
        formData.append("quantity", 1);
        formData.append(
          "sections",
          cartNotification.getSectionsToRender().map((section) => section.id)
        );
        formData.append("sections_url", window.location.pathname);
        formData.append("key", variant_id);
        formData.append("properties[Anzahl]", 1);
        if (greetingText.trim() !== "") {
          formData.append("properties[Grußtext]", greetingText);
        }

        formData.append("properties[_ProductForType]", productForType);
        formData.append("properties[_Spenden_Betrag]", donationAmount);
        formData.append("properties[_DonationProjectTag]", donationProjectTag);
        formData.append("properties[_DonationCartTitle]", donationCartTitle);
        formData.append("properties[_ProcessingCost]", processingCost);

        if (checkboxPrintOut) {
          formData.append("properties[Email-Adresse]", email);
        } else {
          formData.append("properties[Lieferadresse]", address);
          formData.append("properties[_LieferadresseJson]", addressObj);
          formData.append("properties[_ShippingCost]", shippingCost);
        }

        let formDataTmp = {
          items: [
            {
              id: variant_id,
              quantity: 1,
              properties: {
                ProductForType: productForType,
                Anzahl: 1,
                ...(greetingText.trim() !== "" && {
                  Grußtext: greetingText,
                }),
                ...(address && {
                  Lieferadresse: address,
                }),
                ...(email && {
                  Email: email,
                }),
                _DonationProjectTag: donationProjectTag,
                _DonationCartTitle: donationCartTitle,
              },
            },
          ],
          sections: cartNotification
            .getSectionsToRender()
            .map((section) => section.id),
          sections_url: window.location.pathname,
          key: variant_id,
        };

        await addToCartWithRetry(formData, async (response) => {
          if (localStorage.getItem("cartData")) {
            let cartItems = JSON.parse(localStorage.getItem("cartData"));
            let newItem = formDataTmp["items"][0];
            newItem.img = document.querySelector("product-media img").src;
            newItem.price = amount;
            donationCartTitle && (newItem.title = donationCartTitle);
            newItem.handle = location.href;
            cartItems.unshift(newItem);
            localStorage.setItem("cartData", JSON.stringify(cartItems));
          } else {
            let newItem = formDataTmp["items"][0];
            newItem.img = document.querySelector("product-media img").src;
            newItem.img = document.querySelector("product-media img").src;
            newItem.price = amount;
            donationCartTitle && (newItem.title = donationCartTitle);
            newItem.handle = location.href;
            localStorage.setItem("cartData", JSON.stringify([newItem]));
          }

          // location.href = "/cart";
          await checkCartPrice(response.id);
        });
      };
      await atc();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

let updateCartItem = (variantId) => {
  const isValid = validateInputs();
  if (!isValid) return;

  let ProductForType = "";
  const activeTabName = [...document.querySelectorAll(".tab")]
    .find((tab) => tab.classList.contains("active"))
    .getAttribute("data-tab-name");

  if (activeTabName == "for-me") {
    var quantity = document.querySelector("#amount-input").value;
  } else {
    var quantity = document.querySelector("#gift-amount-input").value;
  }

  const calendarTypeSelector =
    activeTabName === "for-me" ? "calendar-type" : "gift-calendar-type";
  const languageSelector =
    activeTabName === "for-me" ? "language" : "gift-language";

  const calendarType = document.getElementById(calendarTypeSelector).value;
  const language = document.getElementById(languageSelector).value;

  var address = "";
  var addressObj = "";
  if (calendarType == "Papierkalender") {
    if (activeTabName == "for-me") {
      var address = document.getElementById("shipping_address_for_me").value;

      var form2 = document.getElementById("info-form");
      var formData2 = new FormData(form2);

      var addressDataObj = {};
      formData2.forEach((value, key) => {
        addressDataObj[key] = value;
      });
      var addressObj = JSON.stringify(addressDataObj);
    } else {
      var address = document.getElementById("shipping_address").value;

      var form2 = document.getElementById("info-form");
      var formData2 = new FormData(form2);

      var addressDataObj = {};
      formData2.forEach((value, key) => {
        addressDataObj[key] = value;
      });
      var addressObj = JSON.stringify(addressDataObj);
    }
  }

  // Null-safe cost reader (checkout-freeze fix): the price-summary spans are only
  // rendered by calculateTotal() after the address popup was saved via "Speichern".
  // Reading them unguarded crashed the Warenkorb handler silently when the
  // customer filled the address but never saved it.
  var readCostFromElement = function (elementId) {
    var el = document.getElementById(elementId);
    if (!el) return "";
    var match = el.textContent.match(/\d+([,\.]\d+)?/);
    return match ? match[0].replace(",", ".") : "";
  };

  var shippingCost = "";
  if (calendarType == "Papierkalender") {
    if (activeTabName == "for-me") {
      var shippingCost = readCostFromElement("for-me-paper__shipping_cost");
    } else {
      var shippingCost = readCostFromElement("as-gift-paper__shipping_cost");
    }
  }

  var cardDesignCost = "";
  if (calendarType == "Papierkalender" && activeTabName == "as-gift") {
    var el = document.getElementById("as-gift-paper__card_design");

    if (el) {
      var match = el.textContent.match(/\d+([,\.]\d+)?/);
      if (match) {
        cardDesignCost = match[0].replace(",", ".");
      }
    }
  }

  var implementationCost = "";
  if (calendarType == "Digitaler Kalender") {
    var implementationCost = readCostFromElement("digital__implementation_cost");
  }

  var email = "";
  var greetingText = "";
  var shippingDate = null;
  var digitalReceiverName = "";
  var donationAmount = 0;
  let amount = 0;
  if (activeTabName == "for-me") {
    if (calendarType == "Papierkalender") {
      ProductForType = "for-me";
      shippingDate = document.getElementById("shipping-date").value;
      email = document.getElementById("email-input").value;
      donationAmount = document.querySelector("#donation-amount").value;
      amount = document
        .getElementById("for-me-paper__amount")
        .textContent.match(/\d+([,\.]\d+)?/)[0]
        .replace(",", ".");
    } else {
      amount = document
        .getElementById("for-me-digital__amount")
        .textContent.match(/\d+([,\.]\d+)?/)[0]
        .replace(",", ".");
      donationAmount = document.querySelector("#digital-donation-amount").value;
    }
  } else {
    if (calendarType == "Papierkalender") {
      ProductForType = "as-gift";
      shippingDate = document.getElementById("gift-shipping-date").value;

      const recipientImageInput = document.getElementById(
        "recipient-greeting-image"
      );
      const recipientImageFile = recipientImageInput.files[0];
      if (
        !recipientImageFile &&
        typeof window.createDefaultCanvas === "function"
      ) {
        window.createDefaultCanvas();
      }
      donationAmount = document.querySelector("#gift-donation-amount").value;
      amount = document
        .getElementById("as-gift-paper__amount")
        .textContent.match(/\d+([,\.]\d+)?/)[0]
        .replace(",", ".");
    } else {
      email = document.getElementById("gift-digital-email-input").value;
      var greetingText = document
        .getElementById("digital-greeting-text")
        .value.replace(/\n/g, "\r\n");
      var digitalReceiverName = document.getElementById("gift-your-name").value;
      donationAmount = document.querySelector(
        "#gift-digital-donation-amount"
      ).value;
      amount = document
        .getElementById("as-gift-digital__amount")
        .textContent.match(/\d+([,\.]\d+)?/)[0]
        .replace(",", ".");
    }
  }

  // Prevent comma at the end
  if (donationAmount.endsWith(",")) {
    donationAmount = donationAmount.slice(0, -1);
  }
  donationAmount = donationAmount.replace(/[^0-9,]/g, "").replace(",", ".");

  const errorElement = document.getElementById("variation-error");
  errorElement.style.display = "none";

  const submitButton = document.querySelector("#donate-now");
  const cartNotification = document.querySelector("cart-notification");

  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  document
    .querySelector(".loading-overlay__spinner")
    .classList.remove("hidden");

  const body = JSON.stringify({
    price: `${amount}`,
    variant_id: variantId,
  });
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  };

  // Make the POST request
  fetch(updateVariantUrl, options)
    .then((response) => {
      if (!response.ok) {
        errorElement.style.display = "block";
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // adding product to cart
      let atc = () => {
        // let variant_id = data.variant.id;
        const recipientTextInput = document.getElementById(
          "recipient-greeting-text"
        ).value;
        const imagePreview = document.getElementById("image-preview").value;
        const recipientImageInput = document.getElementById(
          "recipient-greeting-image"
        );
        const recipientImageFile = recipientImageInput.files[0];
        // const recipientGreetingImageJson = document.getElementById(
        //   "recipient-greeting-image-json"
        // ).value;

        const properties = {};
        // Add conditional properties
        if (activeTabName == "for-me" || activeTabName == "as-gift") {
          properties["Art"] =
            activeTabName == "for-me" ? "Für mich" : "Als Geschenk";
        }

        properties["Typ"] = calendarType;
        properties["Sprache"] = language;

        if (quantity.trim() !== "") {
          properties["Anzahl"] = parseInt(quantity);
        }
        if (email.trim() !== "") {
          properties["Email-Adresse"] = email;
        }
        if (shippingDate) {
          properties["Versanddatum"] = shippingDate;
        }
        if (greetingText.trim() !== "") {
          properties["Grußtext"] = greetingText;
        }
        if (digitalReceiverName.trim() !== "") {
          properties["_DigitalReceiverName"] = digitalReceiverName;
        }
        if (shippingCost.trim() !== "") {
          properties["_ShippingCost"] = shippingCost;
        }
        if (cardDesignCost.trim() !== "") {
          properties["_CardDesignCost"] = cardDesignCost;
        }

        if (implementationCost.trim() !== "") {
          properties["_ImplementationCost"] = implementationCost;
        }
        properties["Lieferadresse"] = address;
        properties["_LieferadresseJson"] = addressObj;
        properties["_ProductForType"] = activeTabName;

        // Handle image/text input
        if (recipientImageFile) {
          if (imagePreview.length > 0) {
            properties["_Grußkarte"] = recipientImageFile;
            // properties["_GrußkarteJson"] = recipientGreetingImageJson;
          } else {
            properties["Grußtext"] = recipientTextInput;
          }
        }
        properties["_Spenden_Betrag"] = donationAmount;

        // Prepare the update data
        const updates = {
          id: variantId,
          properties: properties,
        };
        fetch(window.Shopify.routes.root + "cart/change.js", {
          method: "POST",
          body: JSON.stringify(updates),
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((response) => {
            // console.log(localStorage.getItem("cartData"));

            let cartItems = JSON.parse(localStorage.getItem("cartData")) || [];

            // The ID of the item you want to update
            const targetId = variantId; // example
            const newPrice = amount; // new price

            // Find and update
            cartItems = cartItems.map((item) => {
              if (item.id == targetId) {
                return { ...item, price: newPrice }; // update price
              }
              return item; // leave others unchanged
            });

            // Save back to localStorage
            localStorage.setItem("cartData", JSON.stringify(cartItems));

            // cart/change.js returns the full cart object (no top-level .id),
            // so pass the line-item variantId that is already in scope here.
            checkCartPrice(variantId);
          });
      };
      atc();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

function validateAllProjectDonationInputs() {
  const minMessage = document.querySelector(
    "input[name='allProjectDonationAmount']"
  ).dataset.minMessage;
  const requiredMessage = document.querySelector(
    "input[name='allProjectDonationAmount']"
  ).dataset.requiredMessage;

  $("#all-project-form").validate({
    rules: {
      allProjectDonationAmount: {
        required: true,
        min: 5,
      },
    },
    messages: {
      allProjectDonationAmount: {
        required: requiredMessage,
        min: minMessage,
      },
    },
    errorClass: "error-validate",
    submitHandler: function () {},
  });

  $("#all-project-form").submit();
  return $("#all-project-form").valid();
}

let allProjectDonateNow = () => {
  const isValid = validateAllProjectDonationInputs();
  if (!isValid) return;

  const productForType = "all-projects";
  const productId = document.querySelector("input[name='product-id']").value;
  const allProjectDonationAmount = document.querySelector(
    "input[name='allProjectDonationAmount']"
  ).value;
  const donationProjectTag =
    document.querySelector("input[name='project-donation-tag']")?.value ?? null;

  const submitButton = document.querySelector("#custom-donate-now");
  const cartNotification = document.querySelector("cart-notification");
  submitButton.setAttribute("aria-disabled", true);
  submitButton.classList.add("loading");
  document
    .querySelector(".loading-overlay__spinner")
    .classList.remove("hidden");

  const body = JSON.stringify({
    donationAmount: `${allProjectDonationAmount}`,
    price: `${allProjectDonationAmount}`,
    product_id: `${productId}`,
    title: `Spendenbetrag ${allProjectDonationAmount}`,
    ProductType: `${productForType}`,
    quantity: 1,
  });
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: body,
  };

  // Make the POST request
  fetch(createVariantUrl, options)
    .then((response) => {
      if (!response.ok) {
        errorElement.style.display = "block";
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(async (data) => {
      // Safety margin on top of backend #331 force-indexing, with label.
      await waitBeforeFirstCartAdd();
      let variant_id = data.variant.id;

      const formData = new FormData();
      formData.append("id", variant_id);
      formData.append("quantity", 1);
      formData.append(
        "sections",
        cartNotification.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      formData.append("key", variant_id);
      formData.append("properties[_ProductForType]", productForType);
      formData.append("properties[_DonationProjectTag]", donationProjectTag);

      let formDataTmp = {
        items: [
          {
            id: variant_id,
            quantity: 1,
            properties: {
              ProductForType: productForType,
              ...(donationProjectTag
                ? { _DonationProjectTag: donationProjectTag }
                : {}),
            },
          },
        ],
        sections: cartNotification
          .getSectionsToRender()
          .map((section) => section.id),
        sections_url: window.location.pathname,
        key: variant_id,
      };

      await addToCartWithRetry(formData, async (response) => {
        if (localStorage.getItem("cartData")) {
          let cartItems = JSON.parse(localStorage.getItem("cartData"));
          let newItem = formDataTmp["items"][0];
          newItem.price = allProjectDonationAmount;
          newItem.handle = location.href;
          cartItems.unshift(newItem);
          localStorage.setItem("cartData", JSON.stringify(cartItems));
        } else {
          let newItem = formDataTmp["items"][0];
          newItem.price = allProjectDonationAmount;
          newItem.handle = location.href;
          localStorage.setItem("cartData", JSON.stringify([newItem]));
        }

        await checkCartPrice(response.id);
      });
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};
